import http from '@/utils/http';

export const getCompetitorGamesById: (payload: any, options?: any) => Promise<any> = (payload, options) => {
  return http({
    url: '/api/v1/homepage/pc/getCompetitorGamesById',
    method: 'post',
    data: payload,
    rawData: true,
    ...options,
  }) as Promise<any>;
};

export const getStudioReportList: (payload: any, options?: any) => Promise<any> = (payload, options) => {
  return http({
    url: `/api/v1/util/studiohub/resource/report`,
    method: 'post',
    data: payload,
    rawData: false,
    ...options,
  }) as Promise<any>;
};